const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

export function validPlanUuid(value) {
  return typeof value === 'string' && UUID_PATTERN.test(value.trim()) ? value.trim().toLowerCase() : null
}

export function availablePlanUuid(value, plans) {
  const uuid = validPlanUuid(value)
  return uuid && availablePlans(plans).some(plan => plan.uuid === uuid) ? uuid : null
}

export function availablePlans(plans) {
  return Array.isArray(plans) ? plans.filter(plan => validPlanUuid(plan?.uuid) && plan.is_active !== false && plan.is_public !== false)
    .map(plan => ({ ...plan, uuid: validPlanUuid(plan.uuid) })) : []
}

// Do not coerce event objects or plan objects into query strings.
export function validConversionSource(value) {
  return ['direct', 'gusto_value_offer', 'gusto_quota_offer', 'gusto_plan_strip'].includes(value) ? value : 'direct'
}

export function checkoutAttribution(value = {}) {
  if (!value || typeof value !== 'object') return {}
  return {
    ...(validPlanUuid(value.offerId) ? { offerId: validPlanUuid(value.offerId) } : {}),
    ...(value.policyVersion === 'gusto-v2' ? { policyVersion: value.policyVersion } : {}),
    ...(['first_execution', 'two_values'].includes(value.variant) ? { variant: value.variant } : {}),
    ...(value.copyVersion === 'gusto-v2-1' ? { copyVersion: value.copyVersion } : {}),
  }
}

export function billingHref(path, value, cycle, source, metadata) {
  const uuid = validPlanUuid(value)
  if (!uuid) return path
  const params = new URLSearchParams({ plan: uuid })
  if (cycle) params.set('cycle', cycle === 'annual' ? 'annual' : 'monthly')
  if (validConversionSource(source) !== 'direct') params.set('source', source)
  const names = { offerId: 'offer_id', policyVersion: 'policy_version', variant: 'variant', copyVersion: 'copy_version' }
  for (const [key, item] of Object.entries(checkoutAttribution(metadata))) params.set(names[key], item)
  return `${path}?${params}`
}

export function selectGustoPlan(plans = [], canonicalUuid) {
  const paid = availablePlans(plans).filter(plan => !plan.is_free && plan.requires_payment !== false
    && (!plan.product || plan.product === 'gusto')
    && Number(plan.price_cents) > 0 && Number(plan.weekly_message_limit) > 0)
  if (canonicalUuid) return paid.find(plan => validPlanUuid(plan.uuid) === validPlanUuid(canonicalUuid)) || null
  // A single eligible public product is unambiguous. Never infer a product from price or popularity.
  return paid.length === 1 ? paid[0] : null
}
